import React from "react";
import "./home.scss";
import Header from "../../section/Header/navbar.jsx";
import Banner from "../../section/Banner/Banner.jsx";
import About from "../../section/about/about.jsx";
import New from "../../section/New/New.jsx";
import CSoon from "../../section/Soon/Csoon.jsx";
import Finore from "../../section/Finore/Finore.jsx";
import Bellefont from "../../section/Bellefont/Bellefont.jsx";
import Promo from "../../section/promo/promo.jsx";
import Promohut from "../../section/promohut/promoanniv.jsx";
import Fasilitas from "../../section/fasilitas/fasilitas.jsx";
import Lokasi from "../../section/Lokasi/lokasi.jsx";
import Footer from "../../section/Footer/footer.jsx";
import Rumah from "../../section/Produk/produk.jsx";
import Apartemen from "../../section/Apartemen/apartemen.jsx";
import Ruko from "../../section/Ruko/ruko.jsx";

import Surrounding from "../../section/Surrounding Area/surrounding.jsx";
import ScrollToHashElement from "./ScrollToHashElement";
import Tombol from "../../media/tombol.webp";
import Soon from "../../section/comingsoon/soon.jsx";

const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Promo,%20Brosur,%20dan Katalog%20produk%20terbaru%20Summarecon%20Serpong%20https://marketinggadingserpong.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="home">
      <ScrollToHashElement />
      <Header />
      <Banner />
      <About />
      <New />
      <Finore />
      <CSoon />
      <Bellefont />
      <Soon />

      <Promohut />

      <Promo />

      <Rumah />
      <Apartemen />
      <Fasilitas />
      <Ruko />
      <Surrounding />
      <Lokasi />
      <Footer />
      <img
        onClick={fungsiganteng}
        src={Tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </div>
  );
};

export default home;
